class FirehawkScriptInject {

    unique = 0;

    constructor() {

    }

    inject(type, url, id, callback) {
        let state = {
            type: type,
            listeners: [],
            id: this.uuid(id),
            loaded: false
        }

        this.load(state, document, url, callback)
        return state
    }

    uuid(prefix) {
        const date = new Date();
        const time = date.getTime();
        const random = Math.floor(Math.random() * 1000000000);

        this.unique++;

        return prefix + '_' + random + this.unique + String(time);
    }

    injectScriptTag(id, doc, url, callback) {
        const scriptTag = doc.createElement('script');
        scriptTag.type = 'application/javascript';
        scriptTag.id = id;
        scriptTag.crossOrigin = "anonymous"
        scriptTag.addEventListener('load', callback);
        scriptTag.src = url;
        
        if (doc.head) {
            doc.head.appendChild(scriptTag);
        }
    }

    injectStyleTag(id, doc, url, callback) {
        const scriptTag = doc.createElement('link');
        scriptTag.id = id;
        scriptTag.crossOrigin = "anonymous"
        scriptTag.addEventListener('load', callback);
        scriptTag.href = url;
        scriptTag.rel = "stylesheet"
        if (doc.head) {
            doc.head.appendChild(scriptTag);
        }
    }

    load(state, doc, url, callback) {
        if (state.loaded) {
            callback();
        } else {
            state.listeners.push(callback);

            if (!doc.getElementById(state.id)) {
                if (state.type == "style") {
                    this.injectStyleTag(state.id, doc, url, () => {
                        state.listeners.forEach((fn) => fn());
                        state.loaded = true;
                    })
                } else {
                    this.injectScriptTag(state.id, doc, url, () => {
                        state.listeners.forEach((fn) => fn());
                        state.loaded = true;
                    })
                }
            }
        }
    }
}





